// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IExistingOnFileWallet } from './IExistingOnFileWallet';
import {
    IExistingOnFileWalletFromJSON,
    IExistingOnFileWalletFromJSONTyped,
    IExistingOnFileWalletToJSON,
    IExistingOnFileWalletToJSONTyped,
} from './IExistingOnFileWallet';
import type { IEligibleOnFileWallet } from './IEligibleOnFileWallet';
import {
    IEligibleOnFileWalletFromJSON,
    IEligibleOnFileWalletFromJSONTyped,
    IEligibleOnFileWalletToJSON,
    IEligibleOnFileWalletToJSONTyped,
} from './IEligibleOnFileWallet';
import type { IHeader } from './IHeader';
import {
    IHeaderFromJSON,
    IHeaderFromJSONTyped,
    IHeaderToJSON,
    IHeaderToJSONTyped,
} from './IHeader';
import type { IOnDeviceWallet } from './IOnDeviceWallet';
import {
    IOnDeviceWalletFromJSON,
    IOnDeviceWalletFromJSONTyped,
    IOnDeviceWalletToJSON,
    IOnDeviceWalletToJSONTyped,
} from './IOnDeviceWallet';

/**
 * 
 * @export
 * @interface IGetWalletDataResponse
 */
export interface IGetWalletDataResponse {
    /**
     * 
     * @type {IHeader}
     * @memberof IGetWalletDataResponse
     */
    common?: IHeader;
    /**
     * Echoed from request
     * @type {string}
     * @memberof IGetWalletDataResponse
     */
    correlation_id: string;
    /**
     * success or Failure Code. 0000 - Success 1002 - Invalid PAN 1003 - Ineligible BIN 1004 - Ineligible Device Wallets 1005 - PAN ineligible for Device Wallet 1006 - PAN ineligible for Merchants 1007 - Invalid passthruFromIdiSdk 1008 - Invalid Apple Wallet Certificate 1009 - Field Required 1010 - Issuer Card Art Registration incomplete 1991 - System Error 1993 - Unable to determine provision flow 1994 - PAN Ineligible at TSP 1995 - Unable to prepare encryptedPayload / Unable to prepare registrations / Unable to prepare encryptedPayload 1996 - Unable to create request to TSP / Unable to create request to Samsung / Unable to create request to Google 1997 - Unable to prepare passthruToIdiSdk 1998 - Failure in TSP response / Failure in Samsung response / Failure in Google response 1999 - Error in TSP response
     * @type {string}
     * @memberof IGetWalletDataResponse
     */
    status_code: string;
    /**
     * Description of Status success or Failure, Length 0-256 characters.
     * @type {string}
     * @memberof IGetWalletDataResponse
     */
    status_description?: string | null;
    /**
     * Array contains list of on-file wallets and merchants that are registered to accept push provision of input pan and do not already have input pan.  Hence those walletIds are eligible to receive a push provision for this input pan.
     * @type {Array<IEligibleOnFileWallet>}
     * @memberof IGetWalletDataResponse
     */
    eligible_on_file_wallets?: Array<IEligibleOnFileWallet>;
    /**
     * Array contains list of on-file wallets and merchants that already have input pan tokenized
     * @type {Array<IExistingOnFileWallet>}
     * @memberof IGetWalletDataResponse
     */
    existing_on_file_wallets?: Array<IExistingOnFileWallet>;
    /**
     * Array contains list of on-device pay wallets that are registererd to accept push provision of input pan
     * @type {Array<IOnDeviceWallet>}
     * @memberof IGetWalletDataResponse
     */
    on_device_wallets?: Array<IOnDeviceWallet>;
}

/**
 * Check if a given object implements the IGetWalletDataResponse interface.
 */
export function instanceOfIGetWalletDataResponse(value: object): value is IGetWalletDataResponse {
    if (!('correlation_id' in value) || value['correlation_id'] === undefined) return false;
    if (!('status_code' in value) || value['status_code'] === undefined) return false;
    return true;
}

export function IGetWalletDataResponseFromJSON(json: any): IGetWalletDataResponse {
    return IGetWalletDataResponseFromJSONTyped(json, false);
}

export function IGetWalletDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IGetWalletDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'common': json['common'] == null ? undefined : IHeaderFromJSON(json['common']),
        'correlation_id': json['correlationId'],
        'status_code': json['statusCode'],
        'status_description': json['statusDescription'] == null ? undefined : json['statusDescription'],
        'eligible_on_file_wallets': json['eligibleOnFileWallets'] == null ? undefined : ((json['eligibleOnFileWallets'] as Array<any>).map(IEligibleOnFileWalletFromJSON)),
        'existing_on_file_wallets': json['existingOnFileWallets'] == null ? undefined : ((json['existingOnFileWallets'] as Array<any>).map(IExistingOnFileWalletFromJSON)),
        'on_device_wallets': json['onDeviceWallets'] == null ? undefined : ((json['onDeviceWallets'] as Array<any>).map(IOnDeviceWalletFromJSON)),
    };
}

export function IGetWalletDataResponseToJSON(json: any): IGetWalletDataResponse {
    return IGetWalletDataResponseToJSONTyped(json, false);
}

export function IGetWalletDataResponseToJSONTyped(value?: IGetWalletDataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'common': IHeaderToJSON(value['common']),
        'correlationId': value['correlation_id'],
        'statusCode': value['status_code'],
        'statusDescription': value['status_description'],
        'eligibleOnFileWallets': value['eligible_on_file_wallets'] == null ? undefined : ((value['eligible_on_file_wallets'] as Array<any>).map(IEligibleOnFileWalletToJSON)),
        'existingOnFileWallets': value['existing_on_file_wallets'] == null ? undefined : ((value['existing_on_file_wallets'] as Array<any>).map(IExistingOnFileWalletToJSON)),
        'onDeviceWallets': value['on_device_wallets'] == null ? undefined : ((value['on_device_wallets'] as Array<any>).map(IOnDeviceWalletToJSON)),
    };
}

